import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { Download, Upload, Film, Music, Type } from 'lucide-react';

export function ComposePage() {
  return (
    <div className="p-6 lg:p-8">
      <header className="mb-6 flex items-end justify-between">
        <div>
          <h1 className="text-2xl font-semibold tracking-tight">合成工作台</h1>
          <p className="mt-1 text-sm text-neutral-600">
            三轨时间线(视频 / 音轨 / BGM+字幕) · AI 出粗版 · 本地精剪 · 上传 AI 复审
          </p>
        </div>
        <div className="flex gap-2">
          <Button variant="secondary" size="sm">
            <Download className="h-4 w-4" /> 下载粗版去本地精剪
          </Button>
          <Button variant="agent" agentColor="director" size="sm">
            <Upload className="h-4 w-4" /> 上传精剪稿
          </Button>
        </div>
      </header>

      <Card>
        <CardHeader>
          <CardTitle>时间线</CardTitle>
        </CardHeader>
        <CardContent className="space-y-2">
          {[
            { label: '视频', icon: Film, color: '#0061A4', count: 12 },
            { label: '音轨', icon: Music, color: '#7D5260', count: 12 },
            { label: 'BGM + 字幕', icon: Type, color: '#006E1C', count: 3 },
          ].map((track) => (
            <div key={track.label} className="flex items-center gap-2">
              <div className="flex w-24 items-center gap-1 text-xs text-outline">
                <track.icon className="h-3.5 w-3.5" style={{ color: track.color }} />
                {track.label}
              </div>
              <div className="flex h-10 flex-1 gap-0.5 overflow-hidden rounded">
                {Array.from({ length: track.count }).map((_, i) => (
                  <div
                    key={i}
                    className="h-full flex-1 rounded-sm"
                    style={{ background: track.color, opacity: 0.5 + (i % 5) * 0.1 }}
                  />
                ))}
              </div>
            </div>
          ))}
        </CardContent>
      </Card>

      <Card className="mt-4">
        <CardHeader>
          <CardTitle>导出</CardTitle>
        </CardHeader>
        <CardContent className="flex flex-wrap gap-2">
          {['9:16 · 1080×1920 · TikTok', '9:16 · 720×1280 · 抖音轻量', '1:1 · 1080 · 视频号', '16:9 · 1920×1080 · B 站'].map(
            (preset) => (
              <Button key={preset} variant="secondary" size="sm">
                {preset}
              </Button>
            ),
          )}
        </CardContent>
      </Card>
    </div>
  );
}
